<div class="bg-body min-h-screen transition-colors">
  <router-outlet></router-outlet>
  <app-loader *ngIf="isShowLoader"></app-loader>
</div>
